$(document).ready(function() {
  $('#subscriber-activity-table').DataTable({
    processing: true,
    serverSide: false,
    columnDefs: [{ orderable: true, targets: [1, 2, 3, 4] }],
    order: [[3, "asc"]]
  });
});
